export class UpdateFavoritePropertyDTO {
  constructor(public readonly propertyId: string, public readonly isFavorite: boolean) {
  }
}
